import { render, staticRenderFns } from "./CourceModelItem.vue?vue&type=template&id=ec2772d2&scoped=true"
import script from "./CourceModelItem.vue?vue&type=script&lang=js"
export * from "./CourceModelItem.vue?vue&type=script&lang=js"
import style0 from "./CourceModelItem.vue?vue&type=style&index=0&id=ec2772d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2772d2",
  null
  
)

export default component.exports